import React from 'react';
import { Route } from 'react-router-dom';

import AdminRoute from './AdminRoute';
import AuthenticatedRoute from './AuthenticatedRoute';

// Pages
import HomePage from './components/HomePage';

import OrganizationDashboardPage from './components/organization/OrganizationDashboardPage';
import ManagePracticesPage from './components/practice/ManagePracticesPage';
import PracticeDashboardPage from './components/practice/PracticeDashboardPage';
import OrganizationNewPracticePage from './components/practice/NewPracticePage';
import OrganizationSchedulePage from './components/organization/SchedulePage';
import OrganizationScheduleEditPage from './components/organization/ScheduleEditPage';
import OrganizationManagePlanPage from './components/organization/ManagePlanPage';
import OrganizationStatusPage from './components/status/OrganizationStatusPage';
import CriterionDashboardPage from './components/criterion/CriterionDashboardPage';
import OrganizationAllFilesPage from './components/organization/AllFilesPage';

// Consultant
import ConsultantManageOrganizationsPage from './components/consultant/ManageOrganizationsPage';
import ConsultantManageTeamPage from './components/consultant/ManageTeamPage';
import ConsultantNewOrganizationPage from './components/consultant/NewOrganizationPage';
import ConsultantDashboardPage from './components/consultant/ConsultantDashboardPage';
import NewTeamMemberPage from './components/consultant/NewTeamMemberPage';
import ManageOrganizationTeamPage from './components/consultant/ManageOrganizationTeamPage';
import ActivityLogs from './components/consultant/ActivityLogs';

import CreateConsultantPage from './components/group/CreateConsultantPage';
// User
import AccountManagerPage from './components/user/AccountManagerPage';
import ChangePasswordPage from './components/user/change/ChangePasswordPage';
import LoginPage from './components/user/login/LoginPage';
import ResetConfirmPage from './components/user/reset/ResetConfirmPage';
import ResetRequestPage from './components/user/reset/ResetRequestPage';

import NewOrgMemberPage from './components/organization/NewOrgMemberPage';

// Help
import LegendPage from './components/help/LegendPage';

import AxiosHelper from './setupInterceptors.js';

//setup the interceptor for 401s
AxiosHelper.setup();

const Routes = () => {
    return (
        <div className="router-outlet">
            {/* ---- Public Routes ---- */}
            <Route exact path="/account/signin" component={LoginPage} />
            <Route exact path="/index.html" component={LoginPage} />
            <Route exact path="/account/reset" component={ResetRequestPage} />
            <Route exact path="/account/confirm" component={ResetConfirmPage} />
            <Route exact path="/help/legend" component={LegendPage} />

            {/* ---- Routes that require authentication ---- */}
            <AuthenticatedRoute exact path="/" component={HomePage} />

            <AuthenticatedRoute exact path="/user/account" component={AccountManagerPage} />
            <AuthenticatedRoute exact path="/user/account/password" component={ChangePasswordPage} />

            <AuthenticatedRoute exact path="/consultant/dashboard" component={ConsultantDashboardPage} />
            <AuthenticatedRoute exact path="/consultant/organizations" component={ConsultantManageOrganizationsPage} />
            <AuthenticatedRoute exact path="/consultant/organizations/new" component={ConsultantNewOrganizationPage} />
            <AuthenticatedRoute exact path="/consultant/team" component={ConsultantManageTeamPage} />
            <AuthenticatedRoute exact path="/consultant/team/new" component={NewTeamMemberPage} />
            <AuthenticatedRoute exact path="/consultant/team/edit/:userId" component={NewTeamMemberPage} />
            <AuthenticatedRoute exact path="/consultant/activitylogs" component={ActivityLogs} />
            <AuthenticatedRoute exact path="/consultant/activitylogs/:id" component={ActivityLogs} />

            <AuthenticatedRoute exact path="/organization/:organizationId" component={OrganizationDashboardPage} />
            <AuthenticatedRoute exact path="/organization/:organizationId/schedule" component={OrganizationSchedulePage} />
            <AuthenticatedRoute exact path="/organization/:organizationId/schedule/new" component={OrganizationScheduleEditPage} />
            <AuthenticatedRoute exact path="/organization/:organizationId/schedule/:eventId/edit" component={OrganizationScheduleEditPage} />
            <AuthenticatedRoute exact path="/organization/:organizationId/status" component={OrganizationStatusPage} />
            <AuthenticatedRoute exact path="/organization/:organizationId/practices/new" component={OrganizationNewPracticePage} />
            <AuthenticatedRoute exact path="/organization/:organizationId/files" component={OrganizationAllFilesPage} />

            <AuthenticatedRoute exact path="/practice/:practiceId" component={PracticeDashboardPage} />
            <AuthenticatedRoute exact path="/criterion/:criterionId" component={CriterionDashboardPage} />

            {/* Admin Routes */}
            <AdminRoute exact path="/organization/:organizationId/practices" component={ManagePracticesPage} restricted={true} />
            <AdminRoute exact path="/organization/:organizationId/team" component={ManageOrganizationTeamPage} restricted={true} />
            <AdminRoute exact path="/organization/:organizationId/plan" component={OrganizationManagePlanPage} restricted={true} />
            <AuthenticatedRoute exact path="/organization/:organizationId/team/new" component={NewOrgMemberPage} />

            <AuthenticatedRoute exact path="/consultant/purchase" component={CreateConsultantPage} />
        </div>
    );
};

export default Routes;
